import { useState, useEffect } from "react";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
  InputAdornment,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Box,
} from "@mui/material";
import axiosInstance from "../../axiosInstance";

export default function EditEmployeeDialog({
  open,
  onClose,
  employee,
  onUpdate,
}) {
  const [fullName, setFullName] = useState("");
  const [role, setRole] = useState(null);
  const [mobile, setMobile] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (employee) {
      setFullName(employee.fullName);
      setRole(employee.roleId);
      setMobile(employee.mobile);
    }
  }, [employee]);

  const closePopup = () => {
    setFullName(employee.fullName);
    setRole(employee.roleName);
    setMobile(employee.mobile);
    onClose();
  };

  const handleSave = async () => {
    if (!fullName || !role || !mobile) {
      setError("Name, mobile and role are required");
      return;
    }

    setSaving(true);

    try {
      const res = await axiosInstance.put(`/employees/${employee.userId}`, {
        fullName,
        role: { id: role, name: role === 2 ? "Admin" : "Member" },
        mobile,
      });

      onUpdate(res.data.employee);
      closePopup();
    } catch (err) {
      setError("Failed to update employee");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") return;
        closePopup();
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle
        variant="h6"
        fontWeight="bold"
        sx={{
          background: "#f5f5f5",
        }}
      >
        Edit Employee
      </DialogTitle>

      <DialogContent>
        <Box display="grid" gap={2} mt={1}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <TextField
            label="Employee Name"
            fullWidth
            margin="normal"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />

          <TextField
            label="Mobile Number"
            name="mobile"
            fullWidth
            required
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">🇮🇳 +91</InputAdornment>
              ),
              inputMode: "numeric",
            }}
            inputProps={{
              minLength: 10,
              maxLength: 10,
              pattern: "[0-9]{10}",
            }}
          />

          <FormControl fullWidth>
            <InputLabel id="demo-select-label">Role</InputLabel>

            <Select
              labelId="demo-select-label"
              id="demo-select"
              value={role}
              label="Role"
              onChange={(e) => setRole(e.target.value)}
            >
              <MenuItem value={2}>Admin</MenuItem>
              <MenuItem value={3}>Member</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={closePopup}>Cancel</Button>
        <Button variant="contained" disabled={saving} onClick={handleSave}>
          {saving ? "Saving..." : "Save Changes"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}